<template>
  <div ref="printMe">
    <Device 
      :device_guid="this.$route.params.id" 
      :device.sync="device" 
      @update="onUpdated"
      @reset="onResetSensor"/>

    <!-- <Event ref="eventView" :event_height="80" :device_guid="this.$route.params.id"/>

    <History ref="historyView" :device_guid="this.$route.params.id" :device.sync="device"/>

    <CButton color="warning" class="float-right mr-1" @click="print()">프린트</CButton> -->
  </div>
</template>

<script>
import Device from '@/views/swfm/device/Device'
import Event from '@/views/device/Event'
import History from '@/views/device/History'

export default {
  name: 'DeviceManage',
  components: {
    Device,
    Event,
    History
  },
  created: function() {
    // console.log('DeviceManage params: ', this.$route.params)
    this.getDeviceInfo();
  },
  data () {
    return {
      device_guid: this.$route.params.id,
      device: {
        name:'tech9'
      }
    }
  },
  methods: {
    async print() {
      const el = this.$refs.printMe;
      const options = {
        logging: false,
        type: 'dataURL',
        allowTaint : false,
        useCORS: true
      }      
      this.output = await this.$html2canvas(el, options);
      const printWin = window.open('', '', 'width=' + 1000 + ',height=' + 1000);
      printWin.document.open();
      printWin.document.write('<img src="' + this.output + '">');

      printWin.document.addEventListener('load', function() {
          printWin.focus();
          printWin.print();
          printWin.document.close();
          printWin.close();
        }, true
      );
    },
    onUpdated(event) {
      console.log('DeviceManage::onUpdated[updated event was changed from child view] : ', event)
      // this.getDeviceInfo(event.data.guid)
      this.device = event.data;
      // this.device = event;
    },
    onResetSensor(event) {
      console.log('DeviceManage::onResetSensor[deleted all sensor data]')
      // reload info of the device
      this.getDeviceInfo(this.device_guid)
    },
    getDeviceInfo(device_guid) {
      this.$store.dispatch('rest/findById', {model:'devices',guid:this.device_guid})
        .then(device => this.device = device)
    },
    /*****************************************************/
    getSearchDates() {
      return this.$refs.historyView.getDates();
    }
    /*****************************************************/
  }
}
</script>

<style scoped>
.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 0.50rem;
}
</style>